export const SITE_URL =
  process.env.NEXT_PUBLIC_SITE_URL || 'https://test.sakipsabancimuzesi.org'
export const SUCCESS_PASSWORD = 'SUCCESS_PASSWORD'
export const eMUSEUM_PAGINATION_LIMIT = 100
// Eski banner oranları — yeni sayfalar MUSEUM_BANNER_* kullanır (HeroAspectRatio varsayılanı)
export const HERO_ASPECT_RATIO = 2560 / 996
export const HERO_ASPECT_RATIO_MOBILE = 4 / 5
// Drupal müze banner görselleri: masaüstü 2560x1196, mobil 853x1137
export const MUSEUM_BANNER_ASPECT_RATIO = 2560 / 1196
export const MUSEUM_BANNER_ASPECT_RATIO_MOBILE = 853 / 1137
export const TWO_COL_SECTION_IMAGE_ASPECT_RATIO = 640 / 509
export const PUBLICATION_IMAGE_ASPECT_RATIO_ON_MODAL = 4 / 5
export const PUBLICATION_CHILD_IMAGE_ASPECT_RATIO_ON_MODAL = 1
export const ARTIST_IMAGE_ASPECT_RATIO = 4 / 5
export const ARTIST_DETAIL_IMAGE_ASPECT_RATIO = 4 / 5
